import * as PIXI from 'pixi.js';
import { Chart } from './chart';
import { isMobile } from '../../../../core/helpers/isMobile';

export const pixiComponents = {};

export class PixiComponent {
  constructor(width, height) {
    this.app = new PIXI.Application({
      width: width,
      height: height,
      antialias: true,
      autoDensity: true,
      backgroundColor: 'rgba(22, 22, 24, 1)',
      resolution: window.devicePixelRatio * (isMobile() ? 1 : 1.5) || 1,
      preserveDrawingBuffer: true,
      // forceCanvas: !PIXI.utils.isWebGLSupported(),
      powerPreference: 'high-performance',
    });
    window.__PIXI_APP__ = this.app;
    pixiComponents.app = this.app;
    pixiComponents.PixiComponent = this;

    this.chart = new Chart(this.app.stage);
  }

  getView() {
    return this.app.view;
  }

  destroy() {
    this.app.destroy(true, true);
  }
}
